import gql from 'graphql-tag';

export default gql`
    mutation MarkAllAsRead($input: MarkAllReadInput) {
        markAllAsRead(input: $input) {
            errors
        }
    }
`;
